/** Macht hochgeladene Branding-Bilder (`/api/v1/public/website-media/…`) im Browser ladbar. */
export function resolveBrandingAssetUrl(url, apiBase = "") {
    const trimmed = url?.trim() ?? "";
    if (!trimmed)
        return null;
    if (trimmed.startsWith("/api/")) {
        const base = apiBase.replace(/\/$/, "");
        return base ? `${base}${trimmed}` : trimmed;
    }
    return trimmed;
}
/** Setzt das Tab-Icon. Ohne Bild wird ein zuvor gesetztes Icon auf den Seiten-Standard zurückgesetzt. */
export function applyDocumentFavicon(href) {
    if (typeof document === "undefined")
        return;
    const link = document.querySelector('link[rel="icon"]');
    if (!href) {
        if (link?.dataset.brandingManaged === "1") {
            const fallback = link.dataset.brandingFallback ?? "";
            if (fallback)
                link.href = fallback;
            else
                link.remove();
            delete link.dataset.brandingManaged;
        }
        return;
    }
    const icon = link ?? document.createElement("link");
    if (!link) {
        icon.rel = "icon";
        document.head.appendChild(icon);
    }
    else if (!icon.dataset.brandingFallback) {
        const current = icon.getAttribute("href");
        if (current)
            icon.dataset.brandingFallback = current;
    }
    icon.dataset.brandingManaged = "1";
    icon.href = href;
}
